module.exports = __webpack_public_path__ + "img/beijing02.b21ac55b.png";